import { Shimmer } from "components/shimmer";
import React from "react";
import { Separator } from "ui/components/separator";

export function AnalyticsStatsCardPlaceholderWithSeparator() {
  return (
    <div className=" flex flex-1 max-w-64">
      <div className="min-w-32 flex flex-col max-w-52 gap-2 flex-1">
        <div className="flex justify-between text-sm font-medium text-muted-foreground">
          <Shimmer className="w-24 h-4" />
          <Shimmer className="w-10 h-4" />
        </div>
        <Shimmer className="w-32 h-8 md:h-10" />
      </div>
      <Separator
        orientation="vertical"
        className="min-h-16 hidden mx-6 lg:block"
      />
    </div>
  );
}
